import * as React from 'react';
import { UncontrolledCollapse, UncontrolledTooltip } from 'reactstrap';

interface IModalLegalProps {
    title: string;
    tooltip?: boolean;
    coverage: number;
    finalNote?: string;
    consultation: boolean;
    ambulatory: boolean;
    ambulatoryFull: boolean;
    topeMaximoAnual: number;
    information: Record<string, any>;
}

export default function CollapseInformation(props: IModalLegalProps) {
  const { title, tooltip = true, coverage, finalNote = false, consultation, topeMaximoAnual, information, ambulatory, ambulatoryFull } = props;

  const idToggler = title.split(" ").join("-");

  return (
    <>
        <span className="accordion-button position-relative px-16 d-flex cursor-pointer justify-content-between align-content-center align-items-center" id={idToggler + "-Toggler"}>
            {title}
            <i className="material-icons position-absolute">keyboard_arrow_down</i>
        </span>
        <UncontrolledCollapse toggler={"#" + idToggler + "-Toggler"} className="w-100">
            <div className="modal-collapse-layout d-flex flex-column justify-content-center align-items-center align-content-center">
              {Object.keys(information).map(key => (ambulatoryFull || ambulatory) && key !== "Insumos" ?
                <div className="modal-collapse-single-information w-100"> 
                  <h4 className="px-20">{key}</h4>
                  <div className="d-flex flex-wrap">
                    <div className="modal-single-information d-flex justify-content-start align-items-center align-content-center">
                      <p>Cobertura</p>
                      <span>{
                        (!consultation && !ambulatory && !ambulatoryFull) && ["Consulta médica", "Consultas (psiquiatría/psicología)"].includes(key) ?
                        "-" :
                        coverage + "%"
                      }</span>
                    </div>
                    <div className="modal-single-information d-flex justify-content-start align-items-center align-content-center">
                      <p>Tope prestación</p>
                      <span>{information[key]['TP'] || "-"}</span>
                    </div>
                    <div className="modal-single-information d-flex justify-content-start align-items-center align-content-center">
                      <p>Tope Máximo Anual por beneficiario</p>
                      <div className="d-flex">
                        <span>{information[key]['TMA'] || ("UF " + topeMaximoAnual)}</span>
                        {
                          (information[key]['TMA'] !== "-" && tooltip) &&
                          <>
                            <img 
                              src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Tooltip.svg"
                              alt=""
                              id="tooltipToggler" />
                            <UncontrolledTooltip target="#tooltipToggler" innerClassName="custom-tooltip-2" placement="top-end">
                              Suma de todas las coberturas cobradas en un año por cada beneficiario.
                            </UncontrolledTooltip> 
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              : null)}
              {finalNote && <p className="modal-single-note text-left p-0 m-0 px-14 mt-20 w-100">{finalNote}</p>}
            </div>
        </UncontrolledCollapse>
    </>
  );
}
